import React, { FC } from "react";

import Table from "../Table";
import { templateTable } from "../../constants/table";

const Template: FC = () => <Table table={templateTable} />;

export default Template;
